import { render, staticRenderFns } from "./caleden.vue?vue&type=template&id=21f06a84&scoped=true&"
import script from "./caleden.vue?vue&type=script&lang=js&"
export * from "./caleden.vue?vue&type=script&lang=js&"
import style0 from "./caleden.vue?vue&type=style&index=0&id=21f06a84&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f06a84",
  null
  
)

export default component.exports